function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Object) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    const open = $component.isAttributeEnabled(`open`);
    return {
      value: (h("div", {
        "class": {
          'sliding-pane-dropdown': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
          "attrs": __vjadeStringifyAttrsIfObj({
            open,
            'prevent-close-selectors': JSON.stringify([
              `.cohorts-clause-builder-search-input`,
              `.cohorts-clause-clickable mp-autoresizing-input`,
              `mp-context-panel-internal`,
            ]),
          }),
          "on": {
            change: $helpers.dropMenuChanged
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((open) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sliding-pane-drop-menu-content': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'sliding-pane': true
                },
              }, (function() {
                var __jade_nodes = [];
                const panes = $helpers.getPanes();
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (panes);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, pane, paneIdx) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((paneIdx === panes.length - 1) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat($component.child(pane.componentName, {
                            attrs: {
                              'pane-index': paneIdx,
                              'pane-visible': true,
                              'user-id': $attr(`user-id`)
                            }
                          }));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var paneIdx = $$objKey;
                        if ($$obj.hasOwnProperty(paneIdx)) {
                          $$iterated = true;
                          var pane = $$obj[paneIdx];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((paneIdx === panes.length - 1) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat($component.child(pane.componentName, {
                                attrs: {
                                  'pane-index': paneIdx,
                                  'pane-visible': true,
                                  'user-id': $attr(`user-id`)
                                }
                              }));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;